import { all } from 'redux-saga/effects';

import { saga as clientes } from '@ducks/clientes';
import { saga as conectoresBloqueios } from '@ducks/conectoresBloqueios';
import { saga as conectoresComandos } from '@ducks/conectoresComandos';
import { saga as conectoresConexoes } from '@ducks/conectoresConexoes';
import { saga as conectoresConfiguracoes } from '@ducks/conectoresConfiguracoes';
import { saga as conectoresDuplicacao } from '@ducks/conectoresDuplicacao';
import { saga as conectoresFolgas } from '@ducks/conectoresFolgas';
import { saga as conectoresFontesDados } from '@ducks/conectoresFontesDados';
import { saga as conectoresHeaders } from '@ducks/conectoresHeaders';
import { saga as conectoresHorarioFuncionamento } from '@ducks/conectoresHorarioFuncionamento';
import { saga as conectoresLogs } from '@ducks/conectoresLogs';
import { saga as conectoresNotificacao } from '@ducks/conectoresNotificacao';
import { saga as conectoresRequisicoes } from '@ducks/conectoresRequisicoes';
import { saga as conectoresTarefas } from '@ducks/conectoresTarefas';
import { saga as conectoresTemplatesGrupos } from '@ducks/conectoresTemplatesGrupos';
import { saga as conectoresTemplates } from '@ducks/conectoresTemplates';
import { saga as conectoresVersoes } from '@ducks/conectoresVersoes';
import { saga as indicadoresVariaveisAmbiente } from '@ducks/indicadoresVariaveisAmbiente';
import { saga as indicadoresExclusaoDados } from '@ducks/indicadoresExclusaoDados';
import { saga as logsTempos } from '@ducks/logsTempos';
import { saga as login } from '@ducks/login';
import { saga as notificacoes } from '@ducks/notificacoes';

function* rootSaga() {
  yield all([
    ...clientes,
    ...conectoresBloqueios,
    ...conectoresComandos,
    ...conectoresConexoes,
    ...conectoresConfiguracoes,
    ...conectoresDuplicacao,
    ...conectoresFolgas,
    ...conectoresFontesDados,
    ...conectoresHeaders,
    ...conectoresHorarioFuncionamento,
    ...conectoresLogs,
    ...conectoresNotificacao,
    ...conectoresRequisicoes,
    ...conectoresTarefas,
    ...conectoresTemplatesGrupos,
    ...conectoresTemplates,
    ...conectoresVersoes,
    ...indicadoresVariaveisAmbiente,
    ...indicadoresExclusaoDados,
    ...logsTempos,
    ...login,
    ...notificacoes,
  ]);
}

export default rootSaga;
